/* ArteTrofeo · grabado de la vista previa. Mismo cálculo que la app de taller (Relieve 3D): sello arriba, tres líneas
   abajo centradas, letra de trazo único (assets/at-trazo.js) tal como la escribe el cliente, en Línea. */
(() => {
 const SPEC = {
  marca: { w: 195, h: 125, mw: 165, mh: 95, m: 15, sello: 12, l3: [3.5, 2.5] },
  gesta: { w: 230, h: 150, mw: 190, mh: 110, m: 20, sello: 14, l3: [4.5, 3] },
  gestaC: { w: 240, h: 240, mw: 200, mh: 200, m: 20, sello: 14, l3: [4.5, 3] },
  leyenda: { w: 300, h: 210, mw: 250, mh: 160, m: 25, sello: 16, l3: [5.5, 3.5] },
 };
 const SAFE = 1, SEP = ' | ';
 const F = () => window.ATTrazo;
 const glifo = (c) => { const f = F(); return f.g[c] || f.g[c.normalize('NFD')[0]] || f.g['?']; };
 const capH = () => F().cap / F().upm;
 const medir = (t, size, tr) => { const ch = [...t]; return ch.reduce((a, c, i) => a + (glifo(c)[0] * size) / F().upm + (i < ch.length - 1 ? tr * size : 0), 0); };
 const trazo = (t, size, x, y, tr) => {
  const k = size / F().upm;
  let cx = x - medir(t, size, tr) / 2, d = '';
  for (const c of t) {
   const g = glifo(c);
   if (g[1]) for (const s of g[1].split('|')) { const n = s.split(' ').map(Number); for (let i = 0; i + 1 < n.length; i += 2) d += (i ? 'L' : 'M') + (cx + n[i] * k).toFixed(2) + ' ' + (y - n[i + 1] * k).toFixed(2); }
   cx += g[0] * k + tr * size;
  }
  return d;
 };
 // Bloque de líneas centrado en la banda [y0, y1] y ancho maxW; reduce si no cabe (igual que la app)
 const bloque = (items, cx, y0, y1, maxW) => {
  items = items.filter((x) => x[0]);
  if (!items.length) return '';
  const gapK = 0.45;
  let k = 1;
  const caps = items.map(([t, cap, tr]) => { const w = medir(t, cap / capH(), tr); return w > maxW ? cap * (maxW / w) : cap; });
  const total = () => caps.reduce((a, c) => a + c * k, 0) + gapK * caps[0] * k * (caps.length - 1);
  const band = y1 - y0 - 2 * SAFE;
  if (total() > band) k = band / total();
  let y = y0 + SAFE + (band - total()) / 2, d = '';
  items.forEach(([t, cap, tr], i) => { const c = caps[i] * k; y += c; d += trazo(t, c / capH(), cx, y, tr); y += gapK * caps[0] * k; });
  return d;
 };
 const kmFmt = (n) => (Number.isInteger(n) ? String(n) : String(n).replace('.', ','));
 const miles = (n) => String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
 const tiempoOk = (t) => /^\d{1,3}(:[0-5]\d){1,2}$/.test(String(t || '').trim());
 const ritmo = (t, km) => {
  if (!km || !tiempoOk(t)) return '';
  const p = String(t).trim().split(':').map(Number);
  const s = Math.round((p.length === 3 ? p[0] * 3600 + p[1] * 60 + p[2] : p[0] * 60 + p[1]) / km);
  return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0');
 };
 // d = { carrera, km, dm, g ('llana' | 'montana'), nombre, tiempo, dorsal }
 const lineas = (d) => {
  const p2 = [];
  if (d.km) p2.push(kmFmt(d.km) + ' km');
  if (d.g === 'llana') { const r = ritmo(d.tiempo, d.km); if (r) p2.push(r + ' /km'); }
  else if (d.dm != null) p2.push('D+ ' + miles(d.dm) + ' m');
  return [String(d.carrera || '').trim(), p2.join(SEP), [d.nombre, d.tiempo, d.dorsal].map((x) => String(x || '').trim()).filter(Boolean).join(SEP)];
 };
 // Frente del tablero: trazo del texto (mm, origen arriba izq.) y caja del sello. modelo: marca, gesta, gestaC (cuadrado) o leyenda
 const frente = (modelo, L, perfil) => {
  const S = SPEC[modelo];
  if (!S || !F()) return null;
  const { w, h, mw, mh, m } = S, p = Math.max(0, perfil || 0);
  const topY0 = p, topY1 = (h - mh) / 2, botY0 = h - (h - mh) / 2, botY1 = h - p;
  const maxW = Math.min(mw, w - 2 * Math.max(p, m));
  const size = Math.min(S.sello, topY1 - topY0 - 2 * SAFE);
  const d = bloque([[L[0], S.l3[0] * 0.75, 0], [L[1], S.l3[1] * 0.85, 0.01], [L[2], S.l3[1] * 0.85, 0.01]], w / 2, botY0, botY1, maxW);
  return { d, w, h, sello: { x: w / 2 - size / 2, y: (topY0 + topY1) / 2 - size / 2, size } };
 };
 window.ATGrabado = { lineas, frente, SPEC };
})();
